<div id="inner-create-container" class="create-page container-fluid pb-6">
  <div class="h-100 container">
    <div class="h-100 justify-content-center align-items-center row">
      <div class="col-lg-5">
        <div class="card">
          <div class="space mt-4">
            <h4 class="spacel">Forgot Password</h4>
          </div>
          <div class="card-body">
            <!-- Forms Section -->
            <form [formGroup]="forgotPwdForm" (ngSubmit)="handleSubmit()">
              <div class="form-group col-md-12 pb-2">
                <label for="email" class="required">E-mail Address</label>
                <input email required type="email" name="email" class="form-control mt-2" formControlName="email"
                  placeholder="Enter your E-mail Address" maxlength="250" />
                </div>
                @if (
                  forgotPwdForm.controls['email'].invalid &&
                  (forgotPwdForm.controls['email'].dirty ||
                  forgotPwdForm.controls['email'].touched)) {
                  <div
                    class="alert alert-danger">
                    Please enter your email.
                  </div>
                }
                <div class="row mt-2">
                  <div class="col-md-12">
                    <button type="submit" class="btn btn-primary space">Submit</button>
                    <button type="button" [routerLink]="'/login'" class="btn btn-outline-dark">Cancel</button>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>